export default (leaderboard) => {
  return leaderboard.reduce((agg, curr) => {
    if (!agg) {
        agg = curr.reduce((subAgg, subCurr) => {
            if (!subAgg) {
                subAgg = !!(subCurr.valueLabel === 'Total' && subCurr.value);
            }
            return subAgg;
        }, false);
    }
    return agg;
  }, false)
}


// WEBPACK FOOTER //
// ./src/utils/isLeaderboardWithTotal.js